import { render, staticRenderFns } from "./BackgroundImage.vue?vue&type=template&id=0c3a2d32&scoped=true&"
import script from "./BackgroundImage.vue?vue&type=script&lang=js&"
export * from "./BackgroundImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3a2d32",
  null
  
)

export default component.exports